import { render, staticRenderFns } from "./jifenList.vue?vue&type=template&id=29124856&scoped=true"
import script from "./jifenList.vue?vue&type=script&lang=js"
export * from "./jifenList.vue?vue&type=script&lang=js"
import style0 from "./jifenList.vue?vue&type=style&index=0&id=29124856&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29124856",
  null
  
)

export default component.exports